export const categories = [
  {
    key: "hot",
    name: "热梗追踪",
    icon: "ri-fire-line",
    desc: "从第一次出现到全网刷屏，完整记录一个梗的走红轨迹。",
    count: 128,
  },
  {
    key: "meme",
    name: "表情包",
    icon: "ri-emotion-laugh-line",
    desc: "梗图、表情包、聊天必备素材，附出处与使用场景。",
    count: 96,
  },
  {
    key: "recreate",
    name: "二创二改",
    icon: "ri-magic-line",
    desc: "网友二次创作与二次改编作品汇总，灵感源源不断。",
    count: 74,
  },
  {
    key: "comment",
    name: "评论神评",
    icon: "ri-chat-smile-2-line",
    desc: "评论区比正文好看系列，神评与神回复定期盘点。",
    count: 63,
  },
  {
    key: "work",
    name: "打工人日常",
    icon: "ri-briefcase-line",
    desc: "上班摸鱼、辞职文学、工位名场面，打工人的快乐源泉。",
    count: 51,
  },
  {
    key: "ai",
    name: "AI 玩梗",
    icon: "ri-robot-2-line",
    desc: "AI 翻唱、AI 二创、AI 热梗评测，看看机器怎么接梗。",
    count: 38,
  },
];